import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useListCriteria = () =>
  useStore(store => store.criteria)
